import type { WatchlistTranslation } from "./index";

export const english = {
  title: "Insights",
  subtitle_team: "Track what matters in how your team works, and return to recent analyses.",
  subtitle_personal: "Track what matters in how you work, and return to recent analyses.",
  create: "Create",
  track_kpi: "Track a KPI",
  track_kpi_hint: "Monitor something over time",
  run_analysis: "Run an analysis",
  run_analysis_hint: "Ask a one-time question using the current data",
  recent_analyses: "Recent analyses",
  recent_analyses_empty: "Questions you ask in this session appear here.",
  heading: "Ask anything about your processes",
  setup_heading: "What do you want to monitor?",
  ask_placeholder: "Ask about your team's work…",
  ask_another_placeholder: "Ask another question…",
  recent_questions: "Recent conversations",
  delete_chat: "Delete chat",
  chat_deleted: "Chat deleted",
  undo: "Undo",
  dismiss_deleted_chat: "Dismiss deletion notice",
  keep_question_re_running: "Want to keep this question running?",
  include_in_watchlist: "Save to Insights",
  direct_setup_prompt:
    "Track a KPI or watch for changes - a standing question, re-run on a schedule",
  direct_setup_active: "Setting up a Watch — we might clarify its scope before saving.",
  direct_setup_reviewing: "Setting up watch — we might ask clarifying questions next.",
  setup_watch: "Set up watch",
  setup_placeholder: "Specify what you want to track…",
  back_to_ask: "Back to Ask",
  setup_continue: "Continue",
  setup_question_progress: "Question {{current}} of {{total}} (round {{round}})",
  setup_recommended: "Recommended",
  setup_something_else: "Other",
  setup_custom_placeholder: "Type your own answer…",
  setup_back: "Back",
  setup_next: "Next",
  dismiss_keep_question: "Dismiss",
  watch_from_conversation: "Turn this conversation into a recurring question.",
  reviewing: "Reviewing…",
  saved_and_running: "Saved as “{{title}}” — running it now",
  title_placeholder: "Name this alert",
  all_processes: "All processes",
  all_people: "All people",
  select_processes: "Select processes",
  select_people: "Select people",
  scope_people: "{{count}} people",
  scope_people_one: "{{count}} person",
  scope_processes: "{{count}} processes",
  scope_processes_one: "{{count}} process",
  window_last_n_days: "Last {{count}} days",
  runs_weekly: "Runs weekly",
  runs_every_n_days_count: "Runs every {{count}} days",
  every_n_days: "every {{count}} days",
  your_alerts: "Watching",
  kpis_tracking: "KPIs I'm tracking",
  filter_all: "All",
  search_alerts: "Search alerts & KPIs…",
  no_matching_alerts: "No alerts or KPIs match these filters.",
  no_alerts: "Nothing tracked yet. Track a KPI to check a question on a schedule.",
  never_run: "Never run yet",
  chat_about_last_result: "Chat about the latest result",
  back_to_list: "Back to Insights",
  back_to_chat: "Back to Ask",
  view_in_watchlist: "View in Insights",
  chat_empty_hint:
    "Nothing to ask about yet — record and analyze your work first, then interrogate it here.",
  rename_alert: "Rename alert",
  latest_notification: "Latest notification",
  alert_edited_at: "Alert changed · {{at}}",
  unread: "Unread",
  suggestion_apps: "Which apps ate the most time?",
  suggestion_manual_entry: "Time lost to manual data entry",
  suggestion_rework: "Which steps get redone the most?",
  suggestion_outlier: "Who does this process differently from everyone else?",
  suggestion_repetitive: "What's the most repetitive thing we do?",
  suggestion_automation: "What could be automated with the biggest payoff?",
  running: "Active",
  run_now: "Run now",
  run_in_progress: "Running",
  run_failed: "Run failed",
  alert_actions: "Alert actions",
  delete_alert_title: "Delete alert?",
  delete_alert_message:
    "Are you sure you want to delete “{{title}}”? This will stop all future runs and cannot be undone.",
  confirm_delete_alert: "Delete alert",
  delete_alert_failed: "Failed to delete alert",
  remove_from_scope: "Remove from scope",
  days_back: "days back",
  days_between_runs: "days between runs",
} satisfies WatchlistTranslation;
